import { FC, Fragment } from 'react'
import { Flavour } from 'types/Flavour'
import url from 'libraries/front-end-core/core/url'
import { QA_CONTENT, QA_MENU } from 'constants/controllers'
import { AOL_DISPLAY_NAMES } from 'constants/aol/aol'

interface Section {
  id: string
  title: string
}
interface Props {
  path: Section[]
  aol: string
  flavour: Flavour
  sectionId: string
}

const ResultBreadcrumbs: FC<Props> = ({ path, aol, flavour, sectionId }) => {
  const getBreadcrumbUrl = (breadcrumbSectionId: string): string =>
    url(
      QA_CONTENT,
      {
        aol,
        flavour,
        sectionId,
        focusedId: breadcrumbSectionId !== sectionId ? breadcrumbSectionId : undefined
      }
    )

  return (
    <nav
      className={`flex flex-wrap items-center f7 mb2 aol-${aol} lh-copy w-100 wb-word`}
      aria-label='breadcrumb'
    >
      <a
        href={`${url(QA_MENU, { flavour })}#${aol}`}
        className='medium-turquoise no-underline hover-underline hover-cadet-blue nowrap nowrap-m truncate dib v-btm wb-word'
        data-event-category='Q&A'
        data-event-action='Breadcrumb Navigation'
        data-event-label={`Breadcrumb to ${aol}`}
        style={{ maxWidth: 120, textOverflow: 'ellipsis' }}
        tabIndex={0}
      >
        <span className={`nowrap nowrap-m aol-${aol}`}>{AOL_DISPLAY_NAMES[aol as keyof typeof AOL_DISPLAY_NAMES].toUpperCase()}</span>
      </a>
      {path.map((section) => (
        <Fragment key={section.id}>
          <span className='mh2 grey nowrap nowrap-m'>{'>'}</span>
          <a
            href={getBreadcrumbUrl(section.id)}
            className={`aol-${aol} no-underline hover-underline hover-cadet-blue nowrap nowrap-m truncate dib v-btm wb-word`}
            data-event-category='Q&A'
            data-event-action='Breadcrumb Navigation'
            data-event-label={`Breadcrumb to ${section.title}`}
            style={{ maxWidth: 120, textOverflow: 'ellipsis' }}
            tabIndex={0}
          >
            {section.title}
          </a>
        </Fragment>
      ))}
    </nav>
  )
}

export default ResultBreadcrumbs
